<template>
    <div class="font-primary min-h-[calc(100vh-200px)]">
      <h1 class="text-xl p-4">Olvide Mi Contraseña</h1>
      <p class=" text-center text-red-500 w-full" v-if="error">{{ error }}</p>
      <div v-if="!mandoMail" class="flex justify-center">
        <div class="w-full">
          <Label>Ingresa tu correo asociado a tu cuenta</Label>
          <div class="flex justify-center p-2">
            <input type="text" :disabled="desabilitado" placeholder="Dirección de Mail" v-model="mail" class="form-control w-1/3">
          </div>
          <button class="btn btn-danger bg-truered" :disabled="desabilitado" @click="obtenerToken()">Enviar</button>
        </div>
      </div>
      <div v-else>
        <div class="w-full">
          <p>Revise su casilla de la cuenta: {{ mail }}</p>
          <div class="flex justify-center p-2">
            <input class="form-control w-1/3" :disabled="desabilitado" placeholder="Ingrese el codigo de confirmacion" type="text" v-model="token">
          </div>
          <div class="flex justify-center p-2">
            <input class="form-control w-1/3" :disabled="desabilitado" placeholder="Ingrese la nueva contraseña" type="password" v-model="newPass">
          </div>
          <div class="flex justify-center p-2">
            <input class="form-control w-1/3" :disabled="desabilitado" placeholder="Confirme la nueva contraseña" type="password" v-model="confirmar">
          </div>
          <button @click="restablecer()" :disabled="desabilitado" class="btn btn-danger bg-truered p-2">Restablecer contraseña</button>
          <button @click="obtenerToken" :disabled="desabilitado">No recibio un correo? Enviar nuevamente</button>
        </div>
      </div>
    </div>
</template>

<script>
import authService from '@/services/auth.service';
import { defineComponent } from 'vue';

export default defineComponent({
    data() {
      return {
        mandoMail: false,
        mail: '',
        token: '',
        newPass: '',
        confirmar: '',
        error: '',
        desabilitado: false
      }
    },
    methods: {
        restablecer() {
          if (this.newPass) {
            if (this.confirmar) {
              if (this.newPass == this.confirmar) {
                if (this.token) {
                  this.desabilitado = true
                  authService.changePassword(this.mail, this.token, this.newPass)
                    .then(() => {
                      this.$root.alertSuccess = true
                      this.$root.isAlertVisible = true
                      this.$router.push('/catalogo')
                    })
                    .catch(err => {
                      this.desabilitado = false
                      console.log(err)
                      this.error = 'No se realizo el cambio, verifique el codigo de seguridad..'
                    })
                } else {
                  this.error = 'Ingrese un codigo valido..'
                }
              } else {
                this.error = 'Las contraseñas no coinciden..'
              }
            } else {
              this.error = 'Las contraseñas no coinciden..'
            }
          } else {
            this.error = 'La nueva contraseña no puede estar vacia..'
          }
        },
        obtenerToken() {
          if (this.mail) {
            if (this.error == 'Ingrese una dirección de mail') {
              this.error = ''
            }
            this.desabilitado = true
            authService.requestToken(this.mail)
              .then((res) => {
                if (this.error == 'No se pudo enviar el correo, revise la dirección de email') {
                  this.error = ''
                }
                this.desabilitado = false
                console.log(res)
                this.mandoMail = true
              })
              .catch(err => {
                this.desabilitado = false
                console.log(err)
                this.error = 'No se pudo enviar el correo, revise la dirección de email'
              })
          } else {
            this.error = 'Ingrese una dirección de mail'
          }
        }
    }
})
</script>
  